'use client';

import { useEffect } from 'react';

/**
 * Root-level error boundary. Mounts when the error happens IN the root
 * `app/layout.tsx` itself (or higher up the tree than the locale error
 * page can catch). Must render its own <html>/<body> because the layout
 * never finished rendering.
 *
 * Kept English-only with minimal styling — at this depth next-intl
 * hasn't initialised, fonts may not have loaded, and the localised
 * Error namespace isn't reachable. A short, generic message is the
 * realistic option.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
     
    console.error('Global error:', error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#04060a',
          color: '#f3f6f8',
          fontFamily: 'system-ui, sans-serif',
          padding: '2rem',
        }}
      >
        <div style={{ maxWidth: '32rem', textAlign: 'center' }}>
          <h1
            style={{
              fontSize: '2rem',
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              margin: '0 0 1rem',
            }}
          >
            Something went wrong
          </h1>
          <p style={{ color: '#94a3b8', marginBottom: '1.5rem' }}>
            An unexpected error happened. Reload the page or try again
            in a moment.
          </p>
          {error.digest ? (
            <p style={{ fontFamily: 'monospace', fontSize: '0.85rem', color: '#94a3b8' }}>
              <code>{error.digest}</code>
            </p>
          ) : null}
          <button
            type="button"
            onClick={reset}
            style={{
              background: 'transparent',
              border: '1px solid #66bbcd',
              color: '#66bbcd',
              padding: '0.7rem 1.4rem',
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: '0.85rem',
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
            }}
          >
            Try again →
          </button>
        </div>
      </body>
    </html>
  );
}
